import { secondAxios } from "../../../../../../api/axios";

export const getPvHours = async (equipId) => {
  const response = await secondAxios.get(`/cost5d/${equipId}/rev/11/pv-hours`);
  console.log({ response });
  return response.data;
};
